import React from 'react';
import {TextField} from '@sail/ui';

interface FormTextFieldProps {
  label: React.ReactNode;
  description?: React.ReactNode;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'password' | 'tel' | 'url' | 'search' | 'number';
  error?: string;
}

export const FormTextField = ({
  label,
  description,
  placeholder,
  value,
  onChange,
  type,
  error,
}: FormTextFieldProps) => {
  return (
    <TextField
      label={label}
      description={description}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      type={type}
      size="large"
      invalid={!!error}
      error={error}
      subviews={{
        inputs: {
          css: {
            // `inputs` is the wrapper around the input; Sail renders keylines as outside box-shadows,
            // so reserve space to keep the horizontal edges visible.
            paddingX: '1px',
          },
        },
        input: {
          css: {
            height: '36px',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 400,
          },
        },
      }}
    />
  );
};
